import {React, useState} from 'react';
import Popup from './Popup';
import Dropdown from './Dropdown';
import Button from './Button';
import Password from './Password';
import EditText from './EditText';
import Urls from '../Urls'
const NewUser = ({onClose, onAccept}) =>{
const [editables, setEditables] = useState({
    acceso_cotizaciones: false,
    acceso_notas_recepcion: false,
    acceso_inventario: false,
    acceso_catalogo: false,
    acceso_usuarios: false,
    acceso_clientes: false,
    acceso_proceso: false   // ✅ Added
});
  
const [userData, setUserData] = useState({
    is_active: "TRUE",
    acceso_cotizaciones: "NO_ACCESS",
    acceso_notas_recepcion: "NO_ACCESS",
    acceso_inventario: "NO_ACCESS",
    acceso_catalogo: "NO_ACCESS",
    acceso_usuarios: "NO_ACCESS",
    acceso_clientes: "NO_ACCESS",
    acceso_proceso: "NO_ACCESS"  // ✅ Added
});
  
  const handleDropdownChange = (field, value) => {
    setUserData({ ...userData, [field]: value });
  };
  const postData = (url,dataToSend) => {
    console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
          if(data.success === true){
            onAccept()
            alert("Usuario agregado correctamente")

          } else {
            alert("Hubo un problema al agregar el usuario")
          }
          
          console.log(data);
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
  }
  const handleSumbit = () =>{
    if(userData?.nombre?.trim() && userData?.usuario?.trim() && userData?.password?.trim())
    {
      if(userData.password === userData.repeat_password){
        postData(Urls.CREATE_USER,{
        ...userData,
        nombre: userData.apellidos ? `${userData.nombre} ${userData.apellidos}` : userData.nombre
        });
      } else {
        alert("Asegurese de que las contrasenas coincidan")
      }
    } else {
      alert('Asegurese de llenar todos los campos requeridos')
    }
  }
  
  return (
    <Popup title="Agregar Usuario" onClose={() => onClose()}>
      <div className="new-user-container">
        <div className="invisible-horizontal-container">
          <div className="form-field">
            <label>Nombre(s) <span className="required">*</span></label>
            <EditText onChange={(data) => setUserData({...userData, nombre: data})} text="Nombre" />
          </div>
          <div className="form-field">
            <label>Apellidos:</label>
            <EditText onChange={(data) => setUserData({...userData, apellidos: data})} text="Apellidos" />
          </div>
        </div>

        <div className="invisible-horizontal-container">
          <div className="form-field">
            <label>Usuario <span className="required">*</span></label>
            <EditText onChange={(data) => setUserData({...userData, usuario: data})} text="Usuario" />
          </div>
          <div className="form-field">
            <label>Contraseña <span className="required">*</span></label>
            <Password onChange={(data) => setUserData({...userData, password: data})} text="Contraseña" />
          </div>
          <div className="form-field">
            <label>Repetir contraseña <span className="required">*</span></label>
            <Password onChange={(data) => setUserData({...userData, repeat_password: data})} text="Contraseña" />
          </div>
        </div>

        <div className="invisible-horizontal-container">
          <div className="form-field">
            <label>Email:</label>
            <EditText onChange={(data) => setUserData({...userData, email: data})} text="Email" />
          </div>
          <div className="form-field">
            <label>Teléfono:</label>
            <EditText onChange={(data) => setUserData({...userData, telefono: data})} text="Teléfono" />
          </div>
        </div>

        {Object.keys(editables).map((field, index) => (
          <div key={index} className="form-ch">
            <label>{field.replace("acceso_", "Acceso ")}:</label>
            <Dropdown
              options={["NO_ACCESS", "READ", "WRITE"]}
              value={userData[field]}
              returnSelectedOption={(data) => handleDropdownChange(field, data)}
            />
          </div>
        ))}

        <div className="justify-right">
          <Button onClick={() => handleSumbit()} color={"#61BAA5"} text={"Agregar"} />
        </div>
      </div>
    </Popup>
  );
}
export default NewUser;